import React from 'react'
import TopHeader from './components/TopHeader'
import MainHeader from './components/MainHeader'
import Sidebar from './components/Sidebar'
import Footer from './components/Footer'
import '../App.css'
import '../index.css'
import { Route, Routes } from 'react-router-dom'
import HeroCarousel from './components/HeroCarousel'
import Speakers from './components/FeaturedSpeakers'
import FeaturedNews from './components/FeaturedNews'
import FeaturedVideos from './components/FeaturedVideos'
import PhotoGallery from './components/FeaturedPhotoGallery'
import GoogleMap from './components/GoogleMap'
import About from './components/About'
import FeaturedSessions from './components/FeaturedSessions' 
import SessionList from './components/SessionsList'
import FestivalPartner from './components/FeaturedSponsors'

function SiteDemo() {
    return (
        <div>

            <div className="App min-h-screen bg-white">
                <div className="page_loader fixed inset-0 bg-white z-50 flex items-center justify-center hidden">
                    <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
                </div>

                <div className="hidden md:block">
                    <TopHeader />
                </div>
                <MainHeader />
                <Sidebar />

                <Routes>
                    <Route
                        path="/"
                        element={
                            <>
                                <HeroCarousel />
                            </>
                        }
                    />
                </Routes>
                <About />
                <Speakers />
                <FeaturedNews />
                {/* <FeaturedVideos /> */}
                <FeaturedSessions />
                <PhotoGallery />
                <FestivalPartner />
                <GoogleMap />
                <Footer />
            </div>
        </div>
    )
}

export default SiteDemo